import api from '@/api/api'

class CampaignService {
  track(token, params) {
    return api.axios.post('campaign/track', {token, campaign_params: params});
  }
}

export default new CampaignService();
